// attention    提示语
// option       选项按钮
// updeteTitle  updete弹窗标题
// timeWidth    表格-时间-宽度
// menuType     菜单类型
// submitId     添加提交时主键字段名
// createMes    添加时校验必填字段
// childTable   子表格配置
// tableFile    表格中是否有文件

export const tableColumns = {
    '2': {
        attention:'此处添加人员在医院/科室下承担site leader/PCRC工作记录，根据添加记录对应进行加分',
        option:'登记在医院/科室下承担site leader/PCRC工作记录',
        updeteTitle:'在医院/科室下承担site leader/PCRC工作记录',
        timeWidth:200,
        menuType:'hospitalDeptWork',
        submitId:'crcPostHospitalDeptWorkId',
        createMes:[{
            name:'开始时间',
            value:'beginYearMonth'
        },{
            name:'结束时间',
            value:'endYearMonth'
        },{
            name:'负责角色',
            value:'roleCode'
        },{
            name:'医院名称',
            value:'hospitalName'
        }],
        childTable:[{
            title: '负责角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
        }, {
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
        }, {
            title: '科室名称',
            dataIndex: 'departmentName',
            key: 'departmentName',
            render: text => text? text : '-'
        }],
    },
    '3': {
        attention:'此处添加人员品牌维护情况，科室书面表扬或主动推荐项目对应得到加分',
        option:'添加品牌维护记录',
        updeteTitle:'品牌维护记录',
        menuType:'brandMaintenance',
        submitId:'crcPostBrandMaintenanceId',
        tableFile:true,
        createMes:[{
            name:'时间',
            value:'date'
        },{
            name:'医院名称',
            value:'hospitalName'
        },{
            name:'附件',
        }],
        childTable:[ {
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width:150,
        }, {
            title: '科室名称',
            dataIndex: 'departmentName',
            key: 'departmentName',
            width:150,
            render: text => text? text : '-'
        }],
    },
    '4': {
        attention:'此处添加培训分享情况，积极分享对应得到加分',
        option:'添加培训分享记录',
        updeteTitle:'培训分享记录',
        menuType:'trainingSharing',
        submitId:'crcPostTrainingSharingId',
        timeWidth:300,
        tableFile:true,
        createMes:[{
            name:'时间',
            value:'date'
        }],
        childTable:[],
    },
    '5': {
        attention:'此处添加正能量记录，积极主动思考，给公司或团队提出新措施方案或行动，并且对团队战斗力和效益有显著提升加分',
        option:'添加正能量记录',
        updeteTitle:'正能量记录',
        menuType:'positiveEnergy',
        submitId:'crcPostPositiveEnergyId',
        timeWidth:240,
        tableFile:true,
        createMes:[{
            name:'开始时间',
            value:'beginYearMonth'
        },{
            name:'结束时间',
            value:'endYearMonth'
        },{
            name:'说明',
            value:'remark'
        }],
        childTable:[{
            title: '说明',
            dataIndex: 'remark',
            key: 'remark',
            width:100,
        }],
    },
    '6': {
        attention:'此处添加科室投诉或卡项目记录，出现投诉或卡项目情况的人员对应减分',
        option:'添加科室投诉或卡项目记录',
        updeteTitle:'科室投诉或卡项目记录',
        menuType:'deptComplain',
        submitId:'crcPostDeptComplainId',
        timeWidth:100,
        createMes:[{
            name:'时间',
            value:'date'
        },{
            name:'科室投诉或卡项目',
            value:'complainType'
        }],
        childTable:[{
            title: '科室投诉或卡项目',
            dataIndex: 'complainTypeName',
            key: 'complainTypeName',
            width:100,
        }, {
            title: '涉及医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width:100,
        }, {
            title: '涉及科室名称',
            dataIndex: 'departmentName',
            key: 'departmentName',
            width:100,
        }, {
            title: '涉及项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width:120,
        }, {
            title: '说明',
            dataIndex: 'remark',
            key: 'remark',
        }],
    },
    '7': {
        attention:'此处添加既定项目丢失记录，出现项目丢失的人员对应减分',
        option:'添加既定项目丢失记录',
        updeteTitle:'既定项目丢失记录',
        menuType:'establishedInvLost',
        submitId:'crcPostEstablishedInvLostId',
        createMes:[{
            name:'开始时间',
            value:'beginYearMonth'
        },{
            name:'结束时间',
            value:'endYearMonth'
        },{
            name:'医院名称',
            value:'hospitalName'
        }],
        childTable:[{
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
        }, {
            title: '科室名称',
            dataIndex: 'departmentName',
            key: 'departmentName',
        }, {
            title: '负责角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
        }, {
            title: '说明',
            dataIndex: 'remark',
            key: 'remark',
        }],
    },
    '8': {
        attention:'此处添加未参与集体活动记录，未参与人员对应减分',
        option:'添加未参与集体活动记录',
        updeteTitle:'未参与集体活动记录',
        menuType:'notJoinGroupActivity',
        submitId:'crcPostNotJoinGroupActivityId',
        timeWidth:200,
        createMes:[{
            name:'时间',
            value:'date'
        },{
            name:'活动主题',
            value:'remark'
        },],
        childTable:[{
            title: '活动主题',
            dataIndex: 'remark',
            key: 'remark',
        }, {
            title: '未参加原因',
            dataIndex: 'reason',
            key: 'reason',
        }],
    },
    '9': {
        attention:'此处添加负面行为及情绪记录，有此记录人员对应减分',
        option:'添加负面行为及情绪记录',
        updeteTitle:'负面行为及情绪记录',
        menuType:'negativeBehaviourEmotion',
        submitId:'crcPostNegativeBehaviourEmotionId',
        timeWidth:300,
        createMes:[{
            name:'开始时间',
            value:'beginYearMonth'
        },{
            name:'结束时间',
            value:'endYearMonth'
        },{
            name:'具体行为',
            value:'type'
        }],
        childTable:[{
            title: '具体行为',
            dataIndex: 'type',
            key: 'type',
            render: text => {
                let show = ''
                switch(text) {
                    case 'rejectArrange' :
                        show = '拒接项目或不服从安排'
                        break
                    case 'transferNegativeEnergy' :
                        show = '团队传递负能量'
                        break
                    case 'inputDataNotTimely' :
                        show = '各类数据录入不及时'
                        break
                }
                return show
            }
        }],
    },
    //-1: 排名总览加分弹窗新增：带教新人tab
    //-2: 排名总览加分弹窗新增：每季度醒目量和入组量tab
    '-1': {
        timeWidth:300,
        childTable:[{
            title: '季度带教人数',
            dataIndex: 'studentNum',
            key: 'studentNum',
        }],
    },
    '-2': {
        timeWidth:200,
        childTable:[{
            title: '季度参与项目数量',
            dataIndex: 'joinInvNum',
            key: 'joinInvNum',
        }, {
            title: '季度入组数量',
            dataIndex: 'randomAmount',
            key: 'randomAmount',
        }],
    }
}

export const tabs = [{
    tab:'排名总览',
    key:'1',
},{
    tab:'在医院/科室下承担site leader/PCRC工作',
    key:'2',
},{
    tab:'品牌维护',
    key:'3',
},{
    tab:'培训分享',
    key:'4',
},{
    tab:'正能量',
    key:'5',
},{
    tab:'科室投诉或卡项目',
    key:'6',
},{
    tab:'既定项目丢失',
    key:'7',
},{
    tab:'未参与集体活动',
    key:'8',
},{
    tab:'负面行为及情绪',
    key:'9',
}]


// WEBPACK FOOTER //
// ./src/components/user/crcPostRank/pageMes.js